__turbopack_context__.v({
  "billingInfoGrid": "CardFormScreen-module-scss-module__jzEsLG__billingInfoGrid",
  "billingInfoGridWithState": "CardFormScreen-module-scss-module__jzEsLG__billingInfoGridWithState",
  "cardNumberField": "CardFormScreen-module-scss-module__jzEsLG__cardNumberField",
  "changeMethodButton": "CardFormScreen-module-scss-module__jzEsLG__changeMethodButton",
  "formGrid": "CardFormScreen-module-scss-module__jzEsLG__formGrid",
  "label": "CardFormScreen-module-scss-module__jzEsLG__label",
});
